import Box from '@mui/material/Box';

import { type IconKey } from '@/content/site';

import { ContentIcon } from './ContentIcon';

export type IconBadgeTone = 'surface' | 'tint' | 'inverse';

const toneBg: Record<IconBadgeTone, string> = {
  surface: 'surfaceVariant',
  tint: 'rgba(var(--mui-palette-primary-mainChannel) / 0.1)',
  inverse: 'rgba(255,255,255,0.08)',
};

type Props = {
  name: IconKey;
  /** Tile size in px; the icon scales with it. */
  size?: number;
  shape?: 'rounded' | 'circle';
  tone?: IconBadgeTone;
};

/** A brand-red icon on a soft tile. Decorative: the text beside it carries the meaning. */
export function IconBadge({ name, size = 48, shape = 'rounded', tone = 'surface' }: Props) {
  return (
    <Box
      sx={{
        flexShrink: 0,
        width: size,
        height: size,
        borderRadius: shape === 'circle' ? '50%' : 2,
        display: 'grid',
        placeItems: 'center',
        color: 'primary.main',
        bgcolor: toneBg[tone],
      }}
    >
      <ContentIcon name={name} sx={{ fontSize: Math.round(size / 2) }} />
    </Box>
  );
}
